(function() {
	'use strict';

	angular.module('quantixApp')
			.factory('GenericServiceNew', GenericServiceNew);

	GenericServiceNew.$inject = [ '$http', '$q' ];

	function GenericServiceNew($http, $q) {

		var _getCompaniesListByNameNew = function(searchText, module) {

			var deferred = $q.defer();

			var url = 'api/masterData/getCompaniesByName';

			$http.get(url, {
				params : {
					searchText : searchText,
					module : module
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getCompaniesListByNameForCompanyReport = function(searchText) {

			var deferred = $q.defer();

			var url = 'api/masterData/getCompaniesByNameForCompanyReport';

			$http.get(url, {
				params : {
					searchText : searchText
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _getCompaniesListByNameForSME = function(searchText) {

			var deferred = $q.defer();

			var url = 'api/masterData/getCompaniesByNameForSME';

			$http.get(url, {
				params : {
					searchText : searchText
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getAggFinancials = function(industryId) {
			var deferred = $q.defer();

			var url = 'api/industryProfile/getIndustryAggregates';

			$http.post(url, {
				searchText : industryId
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _generateHtmltreegridDataExport = function(htmltreegridData) {

			var deferred = $q.defer();
			$http.post('api/quickScreeningTool/htmltreegridexportdataExcel',
					htmltreegridData, {
						responseType : 'arraybuffer'
					}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _generateAdvSearchHtmltreegridDataExport = function(
				htmltreegridData) {

			var deferred = $q.defer();
			$http.post('api/advanceSearch/htmltreegridexportdataExcel',
					htmltreegridData, {
						responseType : 'arraybuffer'
					}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getDataForPieChart = function() {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getPieChartData';

			// $http.post(url, {indID : compId}).then(function(response) {
			$http.post(url).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		// var _getCompanyDetailsForRatingChart = function(compId) {
		var _getCompanyDetailsForRatingChart = function() {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getRatingChartData';

			// $http.post(url, {indID : compId}).then(function(response) {
			$http.post(url).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getCompaniesListByNameForUser = function(searchText) {

			var deferred = $q.defer();

			var url = 'api/masterData/getCompaniesByName';

			$http.get(url, {
				params : {
					searchText : searchText
				}
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getPortfolioCompanies = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPortfolioCompanies';
			$http.post(url, searchText).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getPortfolioExcelHeaders = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPortfolioExcelHeaders';
			$http.post(url, searchText).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getAxisPortfolioExcelHeaders = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getAxisPortfolioExcelHeaders';
			$http.post(url, searchText).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getSchemeListByName = function(investmentAnalysisInputDTO) {
			var deferred = $q.defer();
			var url = 'api/masterData/getSchemesByName';
			$http.post(url, investmentAnalysisInputDTO).then(
					function(response) {

						deferred.resolve(response.data);

					}, function(errResponse) {
						deferred.reject(errResponse);
					});

			return deferred.promise;
		}
		var _findCompanyNameByCompanyCode = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/masterData/getCompanyNameByCompanyCode';
			$http.post(url, companyCode, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		var _findCompanyPresentOrNot = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/masterData/getCompanyPresentOrNot';
			$http.post(url, companyCode).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

//Added code for 60869
		var _getCompaniesListByCin = function(searchText, module) {

			var deferred = $q.defer();

			var url = 'api/masterData/getCompaniesByCin';

			$http.get(url, {
				params : {
					searchText : searchText,
					module : module
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getCompaniesListForScorecard= function(searchText, module) {

			var deferred = $q.defer();

			var url = 'api/masterData/getCompaniesForScorecard';

			$http.get(url, {
				params : {
					searchText : searchText,
					module : module
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		//end of 60869
		var _uploadCompanyTemplate = function(formData) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/uploadcompanytemplate', formData, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : undefined
                  }}).then(function(response) {
                            deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }
		return {
			getCompaniesListByNameNew : _getCompaniesListByNameNew,
			getCompaniesListByNameForUser : _getCompaniesListByNameForUser,
			getDetailsForRatingChart : _getCompanyDetailsForRatingChart,
			getPortfolioCompanies : _getPortfolioCompanies,
			getPortfolioExcelHeaders : _getPortfolioExcelHeaders,
			getAxisPortfolioExcelHeaders : _getAxisPortfolioExcelHeaders,
			generateHtmltreegridDataExport : _generateHtmltreegridDataExport,
			generateAdvSearchHtmltreegridDataExport : _generateAdvSearchHtmltreegridDataExport,
			getSchemeListByName : _getSchemeListByName,
			getCompaniesListByNameForSME : _getCompaniesListByNameForSME,
			findCompanyPresentOrNot : _findCompanyPresentOrNot,
			findCompanyNameByCompanyCode : _findCompanyNameByCompanyCode,
			getCompaniesListByCin : _getCompaniesListByCin,
			getCompaniesListForScorecard :_getCompaniesListForScorecard,
			getCompaniesListByNameForCompanyReport: _getCompaniesListByNameForCompanyReport,
			uploadCompanyTemplate: _uploadCompanyTemplate
		};
	}
})();
